

define(['squid/index', 'text!./template.html'], function (squid, template) {

    squid.module('xo-title.directive', ['squid']).directive('xoTitle', function () {
        return {
            template: template,
            restrict: 'E',
            scope: {
                titleTxt: '@',
                className: '@'
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-title/dist/directive.js
// module id = ./components/xo-title/dist/directive.js
// module chunks = 1